/* Pairs theme — storefront behaviour. No dependencies. */
(() => {
  const theme = window.theme || { routes: {}, cartType: 'page', moneyFormat: '£{{amount}}' };

  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  /* ------------------------------------------------------------------ */
  /* Money                                                               */
  /* ------------------------------------------------------------------ */
  function formatMoney(cents) {
    const format = theme.moneyFormat || '£{{amount}}';
    const value = (cents / 100);
    const withDelimiters = (n, decimals, thousands, decimal) => {
      const parts = n.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount_no_decimals': return withDelimiters(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelimiters(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelimiters(value, 0, '.', ',');
        default: return withDelimiters(value, 2, ',', '.');
      }
    });
  }

  /* ------------------------------------------------------------------ */
  /* Toast                                                               */
  /* ------------------------------------------------------------------ */
  let toastTimer;
  function toast(message) {
    const el = $('[data-toast]');
    if (!el) return;
    el.textContent = message;
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { el.hidden = true; }, 3000);
  }

  /* ------------------------------------------------------------------ */
  /* Drawers                                                             */
  /* ------------------------------------------------------------------ */
  let lastFocus = null;

  function openDrawer(drawer) {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    const focusable = drawer.querySelector('.drawer__panel button, .drawer__panel a');
    if (focusable) setTimeout(() => focusable.focus(), 50);
  }

  function closeDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open')) document.body.classList.remove('is-locked');
    if (lastFocus) lastFocus.focus();
  }

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-drawer-open]');
    if (opener) {
      event.preventDefault();
      openDrawer(document.getElementById(opener.dataset.drawerOpen));
      return;
    }
    const closer = event.target.closest('[data-drawer-close]');
    if (closer) {
      event.preventDefault();
      closeDrawer(closer.closest('.drawer'));
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    $$('.drawer.is-open').forEach(closeDrawer);
    closeSearch();
    $$('details[data-facet][open]').forEach((d) => d.removeAttribute('open'));
  });

  /* ------------------------------------------------------------------ */
  /* Cart                                                                */
  /* ------------------------------------------------------------------ */
  const CART_SECTION = 'cart-drawer';

  function updateCartCount(count) {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.classList.toggle('is-empty', Number(count) === 0);
    });
  }

  function renderCartDrawer(html, open) {
    const wrapper = document.getElementById(`shopify-section-${CART_SECTION}`);
    if (!wrapper || !html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.getElementById('CartDrawer');
    const current = document.getElementById('CartDrawer');
    if (!fresh || !current) return;
    const wasOpen = current.classList.contains('is-open');
    current.replaceWith(fresh);
    if (open || wasOpen) {
      fresh.classList.add('is-open');
      fresh.setAttribute('aria-hidden', 'false');
      document.body.classList.add('is-locked');
    }
    updateCartCount(fresh.dataset.count);
  }

  async function refreshCart(open = false) {
    if (theme.cartType === 'drawer') {
      const res = await fetch(`${theme.routes.root}?sections=${CART_SECTION}`);
      const data = await res.json();
      renderCartDrawer(data[CART_SECTION], open);
    } else {
      const res = await fetch(`${theme.routes.cart}.js`);
      const cart = await res.json();
      updateCartCount(cart.item_count);
    }
  }

  // Open the cart drawer from the header bag icon.
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-cart-open]');
    if (!trigger || theme.cartType !== 'drawer') return;
    const drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    event.preventDefault();
    openDrawer(drawer);
  });

  // Quantity buttons inside the drawer.
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-qty-change]');
    if (!button) return;
    event.preventDefault();
    const item = button.closest('.cart-item');
    if (item) item.classList.add('is-loading');
    try {
      const res = await fetch(`${theme.routes.cartChange}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          line: Number(button.dataset.line),
          quantity: Math.max(0, Number(button.dataset.qty)),
          sections: [CART_SECTION],
        }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || 'Could not update your bag');
      if (data.sections) renderCartDrawer(data.sections[CART_SECTION], true);
      else await refreshCart(true);
    } catch (error) {
      if (item) item.classList.remove('is-loading');
      toast(error.message);
    }
  });

  // Cart page: submit automatically when a quantity changes.
  document.addEventListener('change', (event) => {
    if (!event.target.matches('[data-cart-qty]')) return;
    const form = event.target.closest('form');
    if (!form) return;
    const update = document.createElement('input');
    update.type = 'hidden';
    update.name = 'update';
    update.value = '1';
    form.appendChild(update);
    form.submit();
  });

  /* ------------------------------------------------------------------ */
  /* Search panel + predictive search                                    */
  /* ------------------------------------------------------------------ */
  function openSearch() {
    const panel = $('[data-search-panel]');
    if (!panel) return;
    panel.hidden = false;
    const input = $('[data-predictive-input]', panel);
    if (input) setTimeout(() => input.focus(), 30);
  }

  function closeSearch() {
    const panel = $('[data-search-panel]');
    if (panel) panel.hidden = true;
  }

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-search-open]')) {
      event.preventDefault();
      const panel = $('[data-search-panel]');
      if (panel && !panel.hidden) closeSearch();
      else openSearch();
      return;
    }
    if (event.target.closest('[data-search-close]')) {
      event.preventDefault();
      closeSearch();
      return;
    }
    const panel = $('[data-search-panel]');
    if (panel && !panel.hidden && !event.target.closest('[data-search-panel]')) closeSearch();
  });

  let searchTimer;
  let searchController;
  document.addEventListener('input', (event) => {
    if (!event.target.matches('[data-predictive-input]')) return;
    const term = event.target.value.trim();
    const results = $('[data-predictive-results]');
    if (!results) return;
    clearTimeout(searchTimer);
    if (term.length < 2) {
      results.innerHTML = '';
      return;
    }
    searchTimer = setTimeout(async () => {
      if (searchController) searchController.abort();
      searchController = new AbortController();
      try {
        const params = new URLSearchParams({
          q: term,
          section_id: 'predictive-search',
          'resources[type]': 'product,collection',
          'resources[limit]': '6',
          'resources[options][fields]': 'title,product_type,vendor,variants.title,tag',
        });
        const res = await fetch(`${theme.routes.predictiveSearch}?${params}`, { signal: searchController.signal });
        if (!res.ok) return;
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const section = doc.getElementById('shopify-section-predictive-search');
        results.innerHTML = section ? section.innerHTML : '';
      } catch (error) {
        if (error.name !== 'AbortError') results.innerHTML = '';
      }
    }, 220);
  });

  /* ------------------------------------------------------------------ */
  /* Rails (horizontal product scrollers)                                */
  /* ------------------------------------------------------------------ */
  function initRail(section) {
    const track = $('[data-rail-track]', section);
    const prev = $('[data-rail-prev]', section);
    const next = $('[data-rail-next]', section);
    if (!track || track.dataset.ready) return;
    track.dataset.ready = 'true';

    const step = () => {
      const item = track.querySelector('.rail__item');
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      const perView = Math.max(1, Math.floor(track.clientWidth / ((item ? item.offsetWidth : 200) + gap)));
      return perView * ((item ? item.offsetWidth : 200) + gap);
    };
    const sync = () => {
      if (prev) prev.disabled = track.scrollLeft <= 4;
      if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    };
    if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -step() }));
    if (next) next.addEventListener('click', () => track.scrollBy({ left: step() }));
    track.addEventListener('scroll', () => window.requestAnimationFrame(sync), { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }

  function initRails(root = document) {
    $$('.rail-section, .section', root).forEach((section) => {
      if ($('[data-rail-track]', section)) initRail(section);
    });
  }

  /* ------------------------------------------------------------------ */
  /* Slideshow                                                           */
  /* ------------------------------------------------------------------ */
  function initSlideshow(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const slides = $$('.slide', root);
    const dots = $$('[data-slide-dot]', root);
    if (slides.length < 2) return;
    let index = 0;
    let timer;

    const go = (i) => {
      index = (i + slides.length) % slides.length;
      slides.forEach((s, n) => s.classList.toggle('is-active', n === index));
      dots.forEach((d, n) => d.classList.toggle('is-active', n === index));
    };
    const play = () => {
      if (root.dataset.autoplay !== 'true') return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      clearInterval(timer);
      timer = setInterval(() => go(index + 1), Number(root.dataset.speed) || 6000);
    };

    const prev = $('[data-slide-prev]', root);
    const next = $('[data-slide-next]', root);
    if (prev) prev.addEventListener('click', () => { go(index - 1); play(); });
    if (next) next.addEventListener('click', () => { go(index + 1); play(); });
    dots.forEach((dot) => dot.addEventListener('click', () => { go(Number(dot.dataset.slideDot)); play(); }));
    root.addEventListener('mouseenter', () => clearInterval(timer));
    root.addEventListener('mouseleave', play);

    // Swipe on touch screens
    let startX = null;
    root.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', (e) => {
      if (startX === null) return;
      const dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) { go(index + (dx < 0 ? 1 : -1)); play(); }
      startX = null;
    });

    play();
  }

  /* ------------------------------------------------------------------ */
  /* Product page                                                        */
  /* ------------------------------------------------------------------ */
  function initProduct(section) {
    if (section.dataset.ready) return;
    section.dataset.ready = 'true';

    const jsonEl = $('[data-product-json]', section);
    if (!jsonEl) return;
    const product = JSON.parse(jsonEl.textContent);
    const optionName = section.dataset.optionName || 'size';
    let needsSelection = section.dataset.needsSelection === 'true';

    /* Gallery */
    const track = $('[data-gallery-track]', section);
    const thumbs = $$('[data-thumb]', section);
    const counter = $('[data-gallery-current]', section);
    const slides = track ? $$('.gallery-main__slide', track) : [];
    let current = 0;

    const pad = (n) => String(n).padStart(2, '0');
    const showSlide = (i, smooth = true) => {
      if (!track || !slides.length) return;
      current = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[current].offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
      markSlide(current);
    };
    const markSlide = (i) => {
      thumbs.forEach((t, n) => t.classList.toggle('is-active', n === i));
      if (counter) counter.textContent = pad(i + 1);
    };
    thumbs.forEach((thumb) => thumb.addEventListener('click', () => showSlide(Number(thumb.dataset.thumb))));
    const prev = $('[data-gallery-prev]', section);
    const next = $('[data-gallery-next]', section);
    if (prev) prev.addEventListener('click', () => showSlide(current === 0 ? slides.length - 1 : current - 1));
    if (next) next.addEventListener('click', () => showSlide(current === slides.length - 1 ? 0 : current + 1));
    if (track) {
      track.addEventListener('scroll', () => {
        window.requestAnimationFrame(() => {
          const i = Math.round(track.scrollLeft / track.clientWidth);
          if (i !== current) { current = i; markSlide(i); }
        });
      }, { passive: true });
    }

    /* Variant picker */
    const fieldsets = $$('[data-option-index]', section);
    const idInput = $('[data-variant-id]', section);
    const addButton = $('[data-add-button]', section);
    const addLabel = $('[data-add-label]', section);
    const priceEl = $('[data-price]', section);
    const dynamic = $('[data-dynamic-checkout]', section);
    const errorEl = $('[data-form-error]', section);

    const selectedOptions = () => fieldsets.map((fs) => {
      const checked = $('input:checked', fs);
      return checked ? checked.value : null;
    });

    const findVariant = (options) => product.variants.find((v) => v.options.every((opt, i) => opt === options[i]));

    const renderPrice = (variant) => {
      if (!priceEl || !variant) return;
      const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      const save = onSale ? Math.floor(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price) : 0;
      priceEl.innerHTML = `
        <div class="price${onSale ? ' price--sale' : ''}">
          <span class="price__current">${formatMoney(variant.price)}</span>
          ${onSale ? `<s class="price__compare">${formatMoney(variant.compare_at_price)}</s><span class="badge badge--sale">Save ${save}%</span>` : ''}
        </div>`;
    };

    // Mark values that have no available variant given the other selections.
    const updateAvailability = (options) => {
      fieldsets.forEach((fs, index) => {
        $$('input[data-option-input]', fs).forEach((input) => {
          const available = product.variants.some((v) => v.available && v.options.every((opt, i) => {
            if (i === index) return opt === input.value;
            return options[i] === null || opt === options[i];
          }));
          const label = input.nextElementSibling;
          if (label) label.classList.toggle('is-unavailable', !available);
        });
      });
    };

    const setButton = (state, variant) => {
      if (!addButton || !addLabel) return;
      if (state === 'select') {
        addButton.disabled = true;
        addLabel.textContent = `Select ${optionName} to add to bag`;
      } else if (state === 'unavailable') {
        addButton.disabled = true;
        addLabel.textContent = 'Unavailable';
      } else if (variant && variant.available) {
        addButton.disabled = false;
        addLabel.textContent = 'Add to bag';
      } else {
        addButton.disabled = true;
        addLabel.textContent = 'Sold out';
      }
    };

    const onOptionChange = (fieldset) => {
      const options = selectedOptions();
      const legendValue = $('[data-option-selected]', fieldset);
      const checked = $('input:checked', fieldset);
      if (legendValue && checked) legendValue.textContent = checked.value;
      updateAvailability(options);
      if (errorEl) errorEl.hidden = true;

      if (options.some((o) => o === null)) {
        setButton('select');
        return;
      }
      needsSelection = false;
      if (dynamic) dynamic.classList.remove('is-disabled');

      const variant = findVariant(options);
      if (!variant) {
        setButton('unavailable');
        return;
      }
      if (idInput) {
        idInput.value = variant.id;
        idInput.disabled = false;
      }
      renderPrice(variant);
      setButton('ready', variant);

      if (variant.featured_media && slides.length) {
        const target = slides.findIndex((s) => s.dataset.mediaId === String(variant.featured_media.id));
        if (target >= 0) showSlide(target);
      }

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    };

    fieldsets.forEach((fs) => {
      fs.addEventListener('change', (event) => {
        if (event.target.matches('[data-option-input]')) onOptionChange(fs);
      });
    });
    updateAvailability(selectedOptions());

    /* Add to bag */
    const form = $('[data-product-form]', section);
    if (form) {
      form.addEventListener('submit', async (event) => {
        if (theme.cartType !== 'drawer') return; // fall back to normal form post → /cart
        event.preventDefault();
        if (needsSelection || !idInput || idInput.disabled) {
          setButton('select');
          return;
        }
        addButton.classList.add('is-loading');
        addButton.disabled = true;
        const original = addLabel.textContent;
        addLabel.textContent = 'Adding…';
        try {
          const body = new FormData(form);
          body.append('sections', CART_SECTION);
          body.append('sections_url', window.location.pathname);
          const res = await fetch(`${theme.routes.cartAdd}.js`, {
            method: 'POST',
            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body,
          });
          const data = await res.json();
          if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not add to bag');
          if (data.sections && data.sections[CART_SECTION]) renderCartDrawer(data.sections[CART_SECTION], true);
          else await refreshCart(true);
          addLabel.textContent = original;
        } catch (error) {
          addLabel.textContent = original;
          if (errorEl) {
            errorEl.textContent = error.message;
            errorEl.hidden = false;
          } else {
            toast(error.message);
          }
        } finally {
          addButton.classList.remove('is-loading');
          addButton.disabled = false;
        }
      });
    }

    /* Share */
    const share = $('[data-share]', section);
    if (share) {
      share.addEventListener('click', async () => {
        const data = { title: share.dataset.title, url: share.dataset.url };
        try {
          if (navigator.share) await navigator.share(data);
          else {
            await navigator.clipboard.writeText(data.url);
            toast('Link copied');
          }
        } catch (e) { /* user cancelled */ }
      });
    }
  }

  /* ------------------------------------------------------------------ */
  /* Product recommendations                                             */
  /* ------------------------------------------------------------------ */
  async function initRecommendations(el) {
    if (el.dataset.ready || !el.dataset.url) return;
    el.dataset.ready = 'true';
    try {
      const res = await fetch(el.dataset.url);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-recommendations]');
      if (fresh && fresh.innerHTML.trim().length) {
        el.innerHTML = fresh.innerHTML;
        initRail(el);
      }
    } catch (e) { /* recommendations are optional */ }
  }

  /* ------------------------------------------------------------------ */
  /* Collection filters                                                  */
  /* ------------------------------------------------------------------ */
  function submitFacets(form) {
    const params = new URLSearchParams();
    new FormData(form).forEach((value, key) => {
      if (String(value).trim() !== '') params.append(key, value);
    });
    window.location.href = `${window.location.pathname}?${params.toString()}`;
  }

  document.addEventListener('change', (event) => {
    const form = event.target.closest('[data-facets-form]');
    if (!form) return;
    if (event.target.type === 'number') return; // price inputs submit on blur/enter
    submitFacets(form);
  });

  document.addEventListener('focusout', (event) => {
    if (event.target.type !== 'number') return;
    const form = event.target.closest('[data-facets-form]');
    if (form && event.target.defaultValue !== event.target.value) submitFacets(form);
  });

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-facets-form]');
    if (!form) return;
    event.preventDefault();
    submitFacets(form);
  });

  // Only keep one filter dropdown open at a time, and close on outside click.
  document.addEventListener('click', (event) => {
    const openFacets = $$('details[data-facet][open]');
    const inside = event.target.closest('details[data-facet]');
    openFacets.forEach((d) => { if (d !== inside) d.removeAttribute('open'); });
  });

  /* ------------------------------------------------------------------ */
  /* Boot (also re-runs inside the theme editor)                         */
  /* ------------------------------------------------------------------ */
  function init(root = document) {
    initRails(root);
    $$('[data-slideshow]', root).forEach(initSlideshow);
    $$('[data-product-section]', root).forEach(initProduct);
    $$('[data-recommendations]', root).forEach(initRecommendations);
    if (root.matches && root.matches('[data-slideshow]')) initSlideshow(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();

  document.addEventListener('shopify:section:load', (event) => init(event.target));

  // Keep the bag count right when the page is restored from the back/forward cache.
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) refreshCart(false).catch(() => {});
  });
})();
